import { useEffect, useState } from "react";

import AuthenticationSMSModal from "./components/AuthenticationSMSModal";
import AuthenticationSecurityModal from "./components/AuthenticationSecurityModal";
import FullWidthModal from "components/FullWidthModal";
import { GetApplicationUserSecurity } from "store/api/security";
import { Grid, useTheme } from "@mui/material";
import { Message } from "assets/Icon";
import SecurityItem from "./components/SecurityItem";
import http from "config/http";
import useNotify from "hooks/useNotify";

function Security({ open, onClose }) {
  const notify = useNotify();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [authenticationDetails, setAuthenticationDetails] = useState(null);

  const [openSmsVerification, setOpenSmsVerification] = useState(false);
  const [openAuthentication, setOpenAuthentication] = useState(false);

  const handleOpenAuthenticationModal = () => {
    setOpenAuthentication(true);
  };

  const handleOpenSmsModal = () => {
    setOpenSmsVerification(true);
  };
  const handleCloseAuthenticationModal = () => {
    setOpenAuthentication(false);
    getApplicationUserSecurity();
  };

  const handleCloseSmsModal = () => {
    setOpenSmsVerification(false);
    getApplicationUserSecurity();
  };

  const getApplicationUserSecurity = async () => {
    setLoading(true);

    try {
      const { data } = await http.get(GetApplicationUserSecurity);

      setAuthenticationDetails(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }

    setLoading(false);
  };

  useEffect(() => {
    getApplicationUserSecurity();

    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FullWidthModal title="امنیت" dir="rtl" open={open} onClose={onClose}>
      {!loading && (
        <Grid container spacing={1} pt={4}>
          <Grid item xs={12}>
            <SecurityItem
              status={authenticationDetails?.isTwoFactorSMSEnabled}
              title="SMS"
              icon={<Message color={theme.palette.text.main}></Message>}
              onClick={handleOpenSmsModal}
            />
          </Grid>

          <Grid item xs={12}>
            <SecurityItem
              status={authenticationDetails?.isTwoFactorAppEnabled}
              title="Authentication"
              icon={<ion-icon name="finger-print"></ion-icon>}
              onClick={handleOpenAuthenticationModal}
              getApplicationUserSecurity={getApplicationUserSecurity}
            />
          </Grid>
        </Grid>
      )}

      {openAuthentication && (
        <AuthenticationSecurityModal
          status={authenticationDetails?.isTwoFactorAppEnabled}
          open={openAuthentication}
          onSuccess={() =>
            setAuthenticationDetails((v) => ({
              ...v,
              isTwoFactorAppEnabled:
                !authenticationDetails?.isTwoFactorAppEnabled,
            }))
          }
          onClose={handleCloseAuthenticationModal}
        />
      )}

      {openSmsVerification && (
        <AuthenticationSMSModal
          status={authenticationDetails?.isTwoFactorSMSEnabled}
          open={openSmsVerification}
          onSuccess={() =>
            setAuthenticationDetails((v) => ({
              ...v,
              isTwoFactorSMSEnabled:
                !authenticationDetails?.isTwoFactorSMSEnabled,
            }))
          }
          onClose={handleCloseSmsModal}
        />
      )}
    </FullWidthModal>
  );
}

export default Security;
